import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const NotificationContainer = ({ children, withNotification }) => {
  return useMemo(() => {
    if (withNotification) {
      return (
        <div className="with-notification-wrapper">
          {children}
          <span className="red-dot" />
        </div>
      );
    }

    return children;
  }, [children, withNotification]);
};

NotificationContainer.propTypes = {
  children: PropTypes.element,
  withNotification: PropTypes.bool,
};

export default NotificationContainer;
